import { csrfToken } from "./csrf_token"

export function sendSlideImpressionBatch(endpoint, slides) {
  if (!endpoint) return

  const valid = slides.filter((slide) => slide.dataset.thingId && slide.dataset.location && slide.dataset.position)
  if (!valid.length) return

  const body = new URLSearchParams({ authenticity_token: csrfToken() })
  valid.forEach((slide, index) => {
    body.append(`slides[${index}][thing_id]`, slide.dataset.thingId)
    body.append(`slides[${index}][loc]`, slide.dataset.location)
    body.append(`slides[${index}][pos]`, slide.dataset.position)
    if (slide.dataset.adId) body.append(`slides[${index}][ad_id]`, slide.dataset.adId)
  })

  if (navigator.sendBeacon) {
    navigator.sendBeacon(endpoint, body)
  } else {
    fetch(endpoint, { method: "POST", body, keepalive: true }).catch(() => {})
  }
}
